<div class="gb-popup">
  <div class="gb-popup-inner">
    <div mat-dialog-title class="gb-popup-header">
      <h2>{{ "conferma-posizione-titolo" | translate }}</h2>
      <h6>{{ "conferma-posizione-sottotitolo" | translate }}</h6>
      <hr />

      <button type="button" [title]="'conferma-posizione-chiudi' | translate"
        attr.aria-label="{{ 'conferma-posizione-chiudi' | translate }}" tabindex="-1"
        class="gb-close-pp gb-button-reset" (click)="close('cancel')">
        <span>
          <em></em>
          <em></em>
          <em></em>
        </span>
        <em class="gb-hidden-visually gb-speak">{{ "conferma-posizione-chiudi" | translate }}</em>
      </button>
    </div>
    <div mat-dialog-content class="gb-popup-main">

      <div class="fieldset">
        <label>{{ "conferma-posizione-descrizione" | translate }}</label>
        <input type="text" class="form-control" readonly="readonly" [value]="data.descrizioneServizio">
      </div>
      <div class="fieldset">
        <label>{{ "conferma-posizione-creditore" | translate }}</label>
        <input type="text" class="form-control" readonly="readonly" [value]="data.descrizioneEnteCreditore">
      </div>
      <div class="fieldset">
        <label>{{ "conferma-posizione-categoria" | translate }}</label>
        <input type="text" class="form-control" readonly="readonly" [value]="data.descrizioneCategoria">
      </div>
      <div class="fieldset">
        <label>{{ "conferma-posizione-causale" | translate }}</label>
        <input type="text" class="form-control" readonly="readonly" [value]="data.causale">
      </div>

    </div>
    <div class="gb-popup-foot mt-5">
      <button type="button" (click)="close('cancel')" class="gb_btncta b outline gb-button-reset small me-3"
        tabindex="-1">
        {{ "conferma-posizione-modifica" | translate }}
      </button>
      <button type="button" (click)="close('ok')" class="gb-button-reset gb_btncta small" tabindex="-1">
        {{ "conferma-posizione-prosegui" | translate }}
      </button>
    </div>
  </div>
</div>
